<template>
  <public-page>
    <swiper :navigation="false" :modules="[Navigation, Autoplay, Pagination]" :loop="true"
            @swiper="onSwiper" class="qyrySwiper">
      <swiper-slide v-for="(item, index) in corporateHonors" :key="item + index">
        <div class="img" v-for="img in item" :key="img">
          <img :src="img" alt="banner" />
          <div class="invertedImage">
            <img :src="img" alt="banner"/>
            <div class="mask"></div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="pagination">
      <div class="item" v-for="(item, index) in corporateHonors.length" :key="'pagination'+index" :class="{'active': rySwiperRef?.realIndex === index}"
      @click="toPage(index)"></div>
    </div>
  </public-page>
</template>

<script setup>
import PublicPage from "./components/publicPage";
import {getCorporateHonors} from "../../apis/gywm";
import {arr2MultipleArr} from "../../utils/tools";

import { Swiper, SwiperSlide, useSwiper  } from "swiper/vue";
import { Navigation, Autoplay, Pagination } from "swiper";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "swiper/css";

function toPage(index) {
 rySwiperRef.value.slideTo(index, 500, false)
}
const rySwiperRef = ref(null)
// 在企业荣誉swiper初始化时 将swiper实例赋值给rySwiperRef，便于后续手动切换使用
function onSwiper(swiper) {
  rySwiperRef.value = swiper
}

/**
 * @description: 获取企业荣誉图片数组，并拼接
 * */
const corporateHonors = ref([])
const corporateHonorsRes = await useAsyncData("getCorporateHonors", () => getCorporateHonors());
if (corporateHonorsRes.data.value.code !== 200) {
  corporateHonors.value = []
  throw createError({statusCode: corporateHonorsRes.data.value.code, statusMessage: encodeURIComponent("获取企业荣誉图片失败")})
} else {
  let honorsData = corporateHonorsRes.data.value.data;
  honorsData.forEach(item => {
    corporateHonors.value.push(import.meta.env.VITE_FILE_HOST + item)
  })
  corporateHonors.value = arr2MultipleArr(corporateHonors.value, 9)
}


// 设置TDK
useHead({
  title: '企业荣誉|关于我们 - 郑州路桥建设投资集团有限公司',
})
</script>

<style scoped lang="scss">
.qyrySwiper {
  margin-top: 20px;
  .swiper-wrapper {
    .swiper-slide {
      display: flex;
      align-items: center;
      //justify-content: space-around;
      flex-wrap: wrap;
      .img {
        display: flex;
        flex-direction: column;
        margin-bottom: 100px;
        margin-left: 70px;
        > img {
          width: 386px;
          height: 270px;
        }
        .invertedImage {
          width: 386px;
          height: 100px;
          position: relative;
          overflow: hidden;
          margin-top: 2px;
          > img {
            width: 386px;
            height: 270px;
            transform: rotateX(180deg);
          }
          .mask {
            width: 386px;
            height: 100px;
            background: linear-gradient(rgba(255,255,255,.8), rgba(255,255,255,1));
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        &:first-child,
        &:nth-child(4),
        &:nth-child(7) {
          margin-left: 0;
        }
      }
    }
  }
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 300px;
  .item {
    width: 68px;
    height: 10px;
    border-radius: 10px;
    background: #D8D8D8;
    margin-right: 24px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
  .active {
    background: var(--main-blue-color);
  }
}
</style>